import { Flex, Image, Link } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { PageSectionTitle } from 'src/components/selfService/layout/PageSectionTitle/PageSectionTitle';

const NEED_HELP_ICON_URL =
  'http://media-cdn.grubhub.com/grubhub-assets/image/upload/v1773311688/corp-management-ui/balance/Need%20Help.png';
const CARE_EMAIL = 'corporatecare@grubhub.com';
const CARE_EMAIL_HREF = `mailto:${CARE_EMAIL}`;
const CARE_PHONE = '(844) 478-2249';

export function BalanceContact(): JSX.Element {
  return (
    <Flex
      flexDirection="row"
      alignItems="stretch"
      display="inline-flex"
      backgroundColor="globals.white"
      borderRadius={4}
      overflow="hidden"
    >
      <Flex alignItems="center" flexShrink={0}>
        <Image
          src={NEED_HELP_ICON_URL}
          alt="Need help"
          height="164px"
          aria-label="Need help"
        />
      </Flex>
      <Flex flexDirection="column" justifyContent="center" mx={4}>
        <PageSectionTitle
          title="Need help?"
          subtitle={
            <>
              Questions? Concerns? We’re here to help. Contact our Care team for
              support at <Link href={CARE_EMAIL_HREF}>{CARE_EMAIL}</Link> or{' '}
              {CARE_PHONE}.
            </>
          }
        />
      </Flex>
    </Flex>
  );
}
